import {getGroupProduct, getPlanType, getProduct, getRiders, getSmokerCodes} from 'ApplicationEntry/api/awdApi';
import ApplicationEntryRouteConstants from 'ApplicationEntry/ApplicationEntryRouteConstants';
import * as CI from 'ApplicationEntry/ducks/ProductsRiders/criticalIllness';
import * as CIY from 'ApplicationEntry/ducks/ProductsRiders/criticalIllnessNY';
import {push} from 'connected-react-router';
import {AsyncResult, Loaded} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import * as RI from '../models/ProductsRiders/RiderInformation';
import * as I from 'immutable';
import {Plan, Product} from 'ApplicationEntry/models/ProductsRiders/PlanModel';

function* getCIProducts() {
  yield takeLatest(CI.CriticalIllnessActionType.GET_CI_PRODUCTS, function*(
    action: ReturnType<typeof CI.getCIProducts>
  ) {
    const response: AsyncResult<Product> = yield call(getProduct, action.payload.friendlyName);

    if (E.isRight(response)) {
      yield put(CI.changeCIProducts(new Loaded(response.right.plans!)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(CI.changeCIProducts(response.left));
    }
  });
}

function* getCIPlanTypes() {
  yield takeLatest(CI.CriticalIllnessActionType.GET_CI_PLANTYPES, function*(
    action: ReturnType<typeof CI.getCIPlanTypes>
  ) {
    const response: AsyncResult<{planTypes: string[]}> = yield call(
      getPlanType,
      action.payload.family,
      action.payload.product
    );
    if (E.isRight(response)) {
      yield put(CI.changeCIPlanTypes(new Loaded(response.right.planTypes)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(CI.changeCIPlanTypes(response.left));
    }
  });
}

function* getCISmokingCodes() {
  yield takeLatest(CI.CriticalIllnessActionType.GET_CI_SMOKERCODES, function*() {
    const response: AsyncResult<{smokingStatusValues: string[]}> = yield call(getSmokerCodes);

    if (E.isRight(response)) {
      yield put(CI.changeCISmokerCodes(new Loaded(response.right.smokingStatusValues)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(CI.changeCISmokerCodes(response.left));
    }
  });
}

function* getRiderInformation() {
  yield takeLatest(CI.CriticalIllnessActionType.GET_RIDER_INFORMATION, function*(
    action: ReturnType<typeof CI.getRiderInformation>
  ) {
    const response: AsyncResult<{
      riders: [{code: string; units: string[]; displayName: string; tracInput: null; classBase: null}];
    }> = yield call(getRiders, action.payload.product);

    if (E.isRight(response)) {
      const filteredRiderInformation = response.right.riders.filter(rcode => rcode.code !== 'CICR1') as RI.RiderCode[];
      filteredRiderInformation[1].code = 'WBR';
      const riderInformation = new RI.default(I.List<string>(), I.List<number>(), filteredRiderInformation);
      yield put(CI.changeRiderInformation(new Loaded(riderInformation)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(CI.changeRiderInformation(response.left));
    }
  });
}

function* getPackageSourceList() {
  yield takeLatest(CI.CriticalIllnessActionType.GET_PACKAGE_SOURCE_LIST, function*(
    action: ReturnType<typeof CI.getPackageSourceList>
  ) {
    const {payload} = action;
    const {caseNumber, planCode} = payload;

    const response: AsyncResult<{packages: object[]}> = yield call(getGroupProduct, caseNumber, planCode);

    if (E.isRight(response)) {
      yield put(CI.changePackageSourceApi(new Loaded(response.right.packages)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(CI.changePackageSourceApi(response.left));
    }
  });
}

function* getPackageSourceCriticalIllnessNYList() {
  yield takeLatest(CIY.CriticalIllnessNYActionType.GET_PACKAGE_SOURCE_LIST, function*(
    action: ReturnType<typeof CIY.getPackageSourceList>
  ) {
    const {payload} = action;
    const {caseNumber, planCode} = payload;

    const response: AsyncResult<{packages: object[]}> = yield call(getGroupProduct, caseNumber, planCode);

    if (E.isRight(response)) {
      yield put(CIY.changePackageSourceApi(new Loaded(response.right.packages)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(CIY.changePackageSourceApi(response.left));
    }
  });
}

export default function*() {
  yield all([
    getCIProducts(),
    getCIPlanTypes(),
    getCISmokingCodes(),
    getRiderInformation(),
    getPackageSourceList(),
    getPackageSourceCriticalIllnessNYList(),
  ]);
}
